import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../data/images';

export default function MenuBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative h-[500px] w-full flex items-center justify-center"
    >
      <motion.img
        src={IMAGES.menu.bench}
        alt="Benny's Pølsevogn"
        className="w-full h-full object-contain"
        whileHover={{ scale: 1.02 }}
        transition={{ duration: 0.3 }}
      />
    </motion.div>
  );
}